<template>
    <div class="container">
        <!-- 内容 -->
        <div class="container-content">
            <div class="container-content-title">日志浏览</div>
            <!-- 日志 -->
            <div class="log">
                <!-- 头部条件 -->
                <div class="case">
                    <div class="header-left">
                        <!-- 搜索框 -->
                        <SearchControl :searchWidth="380" placeholder="搜索用户名" @searchAction="searchAction"></SearchControl>
                        <!-- 日历选择 -->
                        <el-date-picker
                            v-model="dateValue"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="timestamp"
                            @change="selectDateAction"
                            :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                    </div>
                    <!-- 导出日志 -->
                    <div class="button-div">
                        <button @click="exportLog(1)" class="case-export">按条件导出</button>
                        <button @click="exportLog(2)" class="export-btn">导出日志</button>
                    </div>
                </div>
                <!-- 分隔线 -->
                <div class="separate"></div>
                <!-- 日志列表 -->
                <div class="log-list-content" v-infinite-scroll="loadData" infinite-scroll-distance="1">
                    <!-- 显示日志内容 -->
                    <div class="log-content" v-for="(logItem, index) in logList" :key="index">
                        <div class="log-content-date">
                            <span>{{ logItem.date }}</span>
                        </div>
                        <div>
                            <el-timeline>
                                <el-timeline-item
                                v-for="(log, index) in logItem.oper"
                                :key="index">
                                {{ log.date }} {{ log.time }} {{ log.username }} {{ log.operation}}
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <ViewBottom></ViewBottom>
    </div>
</template>
<script>
import ViewBottom from '../../components/ViewBottom.vue';
import SearchControl from '../../components/SearchControl.vue';
import { GetLogList, ExportLogList } from '@/http/api/api-hb'
import { saveAs } from 'file-saver'
export default {
    components: { ViewBottom, SearchControl },
    data() {
        return {
            dateValue: null,
            // 日期限制
            pickerOptions: {
                disabledDate: date => {
                    return date.getTime() > Date.now() || date.getTime() <= 1675612800000
                }
            },
            // 所有日志数组
            logList: [],
            currentPage: 1,
            // 存放日志字典
            logDateObj: {},
            // 搜索关键字
            keywords: null
        }
    },
    methods: {
        // 获取日志
        requestLogList() {
            let params = {
                keyword: this.keywords,
                current: this.currentPage,
                limit: 15
            }
            if (this.dateValue) {
                params.startTime = this.dateValue[0]
                params.endTime = this.dateValue[1]
            }
            GetLogList(params).then(res => {
                if (res.code == 200) {
                    this.currentPage++
                    for(var i = 0; i < res.data.rows.length; i++) {
                        const operation = res.data.rows[i]
                        if (this.logDateObj[operation.date] != undefined) { // 有这个日期
                            // 拿出最后一项添加到oper中
                            var leng = this.logList.length
                            const obj = this.logList[leng-1]
                            obj.oper.push(operation)
                            this.logList[leng-1] = obj
                        } else { // 没有这个日期
                            // 对象中添加进这个日期
                            this.logDateObj[operation.date] = operation.date
                            // 日志数组中添加新的
                            this.logList.push({ date: operation.date, oper: [operation] })
                        }
                    }
                    console.log(this.logList);
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        // 导出日志
        exportLog(type) {
            let params = {}
            if (type == 1) {
                params = {
                    startTime: this.dateValue[0],
                    endTime: this.dateValue[1],
                    keyword: this.keywords,
                }
            }
            ExportLogList(params).then(res => {
                // if (res.code == 200) {
                    // 生成blob文本
                    const blob = new Blob([res], {
                        type: "application/vnd.ms-excel;",
                    });
                    const filename = '日志.xlsx'//decodeURIComponent(res.headers["content-disposition"].split("''")[1])
                    saveAs(blob, filename);
                // } else {
                //     new this.popMessage(res.data.msg, 'warning').showMessage()
                // }
            })
        },
        // 按用户名搜索
        searchAction(keywords) {
            this.keywords = keywords
            this.resetSearchLog()
        },
        // 数据
        loadData() {
            this.requestLogList()
        },
        // 选择了日期
        selectDateAction(value) {
            this.resetSearchLog()
        },
        // 重新搜素日志
        resetSearchLog() {
            this.logList = []
            this.logDateObj = {}
            this.currentPage = 1
            this.requestLogList()
        },
    },
}
</script>
<style scoped>
    /* .container-content {
        width: calc(100% - 32px);
        height: calc(100% - 52px);
        padding: 0 16px;
    } */
    /* .container-content .container-content-title {
        height: 48px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;
        line-height: 48px;
    } */
    .container-content .log {
        width: 100%;
        height: calc(100% - 88px);
        padding: 20px 0;
        border-radius: 6px;
        background-color: #fff;
        overflow: auto;
    }
    .container-content .log .case {
        width: calc(100% - 40px);
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }
    .container-content .log .case .header-left {
        display: flex;
        align-items: center;
    }
    /* 日期选择 */
    .header-left /deep/ .el-range-editor.el-input__inner {
        /* margin: 24px 32px; */
        width: 304px;
        padding: 0 16px;
        border-radius: 6px;
        border: none;
        background: #F4F4F4;
        height: 40px;
    }
    .header-left /deep/.el-date-editor .el-range-input {
        background: none;
    }
    .header-left /deep/ .el-date-editor .el-range-separator {
        line-height: 40px;
    }
    .container-content .log .case .button-div {
        min-width: 260px;
    }
    /* 按钮 */
    .container-content .log .case .button-div button {
        width: 120px;
        height: 40px;
        font-size: 16px;
        font-weight: 500;
        border-radius: 6px;
    }
    .case .button-div .case-export {
        color: #0054A0;
        background: #ECF5FF;
        margin-right: 20px;
    }
    .case .button-div .export-btn {
        color: #FFFFFF;
        background: #0054A0;
    }
    /* 分隔线 */
    .container-content .log .separate {
        width: calc(100% - 40px);
        height: 2px;
        margin: 0 auto;
        background: #D8D8D8;
        opacity: 0.23;
    }
    /* 日志样式 */
    .log-list-content {
        width: 100%;
        height: calc(100% - 82px);
        overflow: auto;
        padding: 10px 0;
        /* background-color: #ff0; */
    }
    .log-content {
        display: flex;
        padding: 0 20px;
    }
    .log-content .log-content-date {
        width: 145px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
        line-height: 25px;
    }
    .log-content .el-timeline-item__content {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #303030;
        line-height: 22px;
    }
</style>